import { render, staticRenderFns } from "./ConsultationsOwnerSelectModal.vue?vue&type=template&id=1b7dd996&"
import script from "./ConsultationsOwnerSelectModal.vue?vue&type=script&lang=ts&"
export * from "./ConsultationsOwnerSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports